module.exports = __webpack_public_path__ + "static/img/logo.a813b98c.png";